'use client';

import { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface VideoTutorialCardProps {
  title: string;
  description: string;
  thumbnail: string;
  alt: string;
  duration: string;
  views: number;
  category: string;
  videoUrl: string;
}

export default function VideoTutorialCard({
  title,
  description,
  thumbnail,
  alt,
  duration,
  views,
  category,
  videoUrl,
}: VideoTutorialCardProps) {
  const [isHydrated, setIsHydrated] = useState(false);

  useState(() => {
    setIsHydrated(true);
  });

  const handlePlay = () => {
    if (!isHydrated) return;
    console.log(`Playing video: ${videoUrl}`);
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden hover:shadow-brand transition-all duration-300 group">
      <div className="relative h-48 overflow-hidden cursor-pointer" onClick={handlePlay}>
        <AppImage
          src={thumbnail}
          alt={alt}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center">
            <Icon name="PlayIcon" size={32} className="text-primary ml-1" />
          </div>
        </div>
        <div className="absolute bottom-3 right-3">
          <span className="px-2 py-1 bg-black/80 text-white text-xs font-medium rounded">
            {duration}
          </span>
        </div>
        <div className="absolute top-3 left-3">
          <span className="px-3 py-1 bg-primary text-primary-foreground text-xs font-semibold rounded-full">
            {category}
          </span>
        </div>
      </div>
      
      <div className="p-5">
        <h3 className="text-lg font-semibold text-text-primary mb-2 line-clamp-2 group-hover:text-primary transition-colors">
          {title}
        </h3>
        <p className="text-sm text-text-secondary mb-4 line-clamp-2">
          {description}
        </p>
        
        <div className="flex items-center justify-between text-xs text-text-secondary">
          <span className="flex items-center space-x-1">
            <Icon name="EyeIcon" size={16} />
            <span>{views.toLocaleString()} views</span>
          </span>
          <button
            onClick={handlePlay}
            disabled={!isHydrated}
            className="flex items-center space-x-1 text-primary hover:text-secondary font-medium transition-colors disabled:opacity-50"
          >
            <span>Watch Now</span>
            <Icon name="ArrowRightIcon" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}